import { AiLoader } from '@makemydeal/dr-shared-components';

import { AICard } from './AiCard/AiCard';
import { AiAltDealStructureCard } from './AiAltDealStructureCard';
import { AltDealStructureProviders } from './AltDealStructureProviders';
import { AiVehicleRecommendationProvider } from './AiVehicleRecommendationSlideout/AiVehicleRecommendationProvider';
import { AiVehicleRecommendationsCard } from './AiVehicleRecommendationsCard';
import { Separator } from './BaseDealContainer.style';
import type { AiInsights } from './hooks/useAiInsights';

type AiInsightsCardsProps = {
    scopeId: string;
    insights: AiInsights;
    isCondensedLayout: boolean;
    showApprovalStatus?: boolean;
};

export const AiInsightsCards = ({
    scopeId,
    insights,
    isCondensedLayout,
    showApprovalStatus = !isCondensedLayout
}: AiInsightsCardsProps) => (
    <>
        {insights.showAffordabilityLoader && (
            <AiLoader
                label="Loading Lender Approval Likelihood..."
                size="medium"
                data-testid="ai-vehicle-affordability-loader"
                ariaHidden={true}
                showLogo={!isCondensedLayout}
            />
        )}
        {insights.showAffordabilityCard && (
            <AICard
                ref={insights.hasLenderProbabilities ? insights.affordabilityCardInViewRef : undefined}
                label="Lender Approval Likelihood"
                dataTestId="vehicle-affordability"
                message={isCondensedLayout ? '' : insights.affordabilityMessage}
                status={showApprovalStatus ? insights.affordabilityStatus : undefined}
                statusText={showApprovalStatus ? insights.lenderApprovalLevel : undefined}
                onHandleLabelClick={insights.openLenderLikelihood}
                onRefresh={insights.refreshInsights}
                canRefresh={insights.shouldShowAIRefreshButton}
                disabled={!insights.hasLenderProbabilities}
                showLogo={!isCondensedLayout}
                creditScoreSource={isCondensedLayout ? undefined : insights.creditScoreSourceLabel}
            />
        )}
        {insights.showRecommendationsLoader && (
            <>
                <Separator />
                <AiLoader
                    label="Loading AI Recommendations..."
                    size="medium"
                    data-testid="ai-vehicle-recommendations-loader"
                    ariaHidden={true}
                    showLogo={!isCondensedLayout}
                />
            </>
        )}
        {insights.showRecommendationsCard && (
            <>
                <Separator />
                <AiVehicleRecommendationProvider>
                    <AiVehicleRecommendationsCard
                        scopeId={scopeId}
                        message={insights.recommendationsMessage}
                        isDisabled={insights.isRecommendationsCTADisabled}
                        condensed={isCondensedLayout}
                    />
                </AiVehicleRecommendationProvider>
            </>
        )}
        {insights.showAltDealStructuresCard && (
            <>
                {/* At max scenarios the card wraps to its own line, so omit the leading
                    separator — we only want a divider between the two links on the first row. */}
                {!insights.isAtMaxScenarios && <Separator />}
                <AltDealStructureProviders>
                    <AiAltDealStructureCard message="AI-optimized financing alternatives." condensed={isCondensedLayout} />
                </AltDealStructureProviders>
            </>
        )}
    </>
);
